import React, {Component} from 'react';
import {Route} from "react-router-dom";
import loadable from "../../loadable";
import CorpApi from "../../public/corp_api";
import Store from "../../store";
import PubSub from "pubsub-js";
import noPermissions from "../../config/noPermissions/noPermissions";

const List = loadable(()=>import('./list'))
const AccountCreate = loadable(()=>import('./accountCreate'))
class Index extends Component {
    constructor(props) {
        super(props);
        this.state={
            accountMessage:{
                isSub:0
            }
        }
    }
    componentDidMount() {
        CorpApi.getUserOpenId((data) => {
            this.setState({
                accountMessage:data
            })
            Store.setUserInfo(data);
        })
    }

    render() {
        return (
            <>
                {/*子账号*/}
                <Route path={this.props.match.url + "/list"} component={this.state.accountMessage.isSub == 0 ? List : this.state.accountMessage.isSub == 1 ? noPermissions : ''}/>
                <Route path={this.props.match.url + "/create"} render={(props)=>{
                    props.type = 'create';
                    return <AccountCreate {...props}/>
                }}/>
                <Route path={this.props.match.url + "/edit/:id"} render={(props)=>{
                    props.type = 'edit';
                    return <AccountCreate {...props}/>
                }}/>
            </>
        );
    }
}

export default Index;